import { Button, Card, CardContent, Switch, Typography } from '@mui/material'
import { useStyles } from '../styles'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { RedirectURLModal } from '../modal'
import React from 'react'
import { ConfirmDeleteModal } from '../modal/confirm-delete.modal'
import { useRedirectURLChangeActive } from 'src/hooks/redirect-urls/use-change-redirect-url-active.hook'
import { IRedirectURLRespDto } from 'src/types/redirect-url.type'

interface IProps {
  item: IRedirectURLRespDto
}

export const Item = ({ item }: IProps) => {
  const classes = useStyles()
  const { mutate } = useRedirectURLChangeActive()
  const [modalOpen, setModalOpen] = React.useState<boolean>(false)
  const [delModalOpen, setDelModalOpen] = React.useState<boolean>(false)

  return (
    <>
      <Card className={classes.cardWrapper}>
        <CardContent className={classes.cardContent}>
          <div className={classes.cardLeftWrapper}>
            {item?.note && (
              <>
                <HelperWrapper t={'redirect-url-note'} />
                <Typography className={classes.cardName} component="h4">
                  {item.note}
                </Typography>
              </>
            )}
            <HelperWrapper t={'redirect-url-text'} />
            <Typography className={classes.cardName} component="h4">
              {item.redirect_url}
            </Typography>
            <HelperWrapper t={'redirect-target-text'} />
            <Typography className={classes.cardName} component="h4">
              {item.redirect_target}
            </Typography>
          </div>
          <div className={classes.btn}>
            <Switch onClick={() => mutate(item.id)} checked={item.active} />
            <Button
              onClick={() => {
                setModalOpen(true)
              }}
            >
              <HelperWrapper t={'update-button-text'} />
            </Button>
            <Button
              onClick={() => {
                setDelModalOpen(true)
              }}
              color="error"
            >
              <HelperWrapper t={'delete-button-text'} />
            </Button>
          </div>
        </CardContent>
        <RedirectURLModal
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          redirectURL={item.redirect_url}
          redirectTarget={item.redirect_target}
          note={item.note}
          id={item.id}
        />
        <ConfirmDeleteModal modalOpen={delModalOpen} setModalOpen={setDelModalOpen} id={item.id} />
      </Card>
    </>
  )
}
